<script setup lang="ts">
	import { computed } from 'vue';
	import { MzAvatar, MzDropdownMenu, MzIcon } from '@monizze/monizze-components';
	import { PhCaretUpDown, PhSignOut, PhUser } from '@phosphor-icons/vue';
	import { useI18n } from 'vue-i18n';
	import { useRouter } from 'vue-router';
	import { useAuthStore } from '@/stores/auth.ts';
	import { useUserStore } from '@/stores/user.ts';

	const props = withDefaults(
		defineProps<{
			/** Side the menu opens on. `right` suits the collapsed sidebar, `top` the expanded one, `bottom` the mobile header. */
			side?: 'top' | 'right' | 'bottom' | 'left';
			/** Hide the name and the caret, keeping only the avatar figure. */
			iconOnly?: boolean;
		}>(),
		{
			side: 'bottom',
			iconOnly: false,
		},
	);

	const { t } = useI18n();
	const router = useRouter();
	const authStore = useAuthStore();
	const userStore = useUserStore();

	const firstName = computed(() => userStore.user.firstname ?? '');

	const avatarIcon = computed(() => (firstName.value ? undefined : PhUser));

	const logout = async () => {
		authStore.logout();
		await router.push('/');
	};
</script>

<template>
	<mz-dropdown-menu
		:side="props.side"
		align="end"
		:items="[
			{
				type: 'item',
				label: t('logout'),
				leadingIcon: PhSignOut,
				onSelect: logout,
			},
		]"
	>
		<template #default="{ open }">
			<mz-avatar
				as="button"
				variant="initials"
				:icon="avatarIcon"
				:title="firstName"
				interactive
				:icon-only="props.iconOnly"
				:highlight="open"
				:class="props.iconOnly ? undefined : 'w-full overflow-hidden'"
			>
				<mz-icon v-if="!props.iconOnly" :icon="PhCaretUpDown" size="sm" />
			</mz-avatar>
		</template>
	</mz-dropdown-menu>
</template>
